import { render, staticRenderFns } from "./CreditorActivity.vue?vue&type=template&id=ee684714&scoped=true"
import script from "./CreditorActivity.vue?vue&type=script&lang=js"
export * from "./CreditorActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee684714",
  null
  
)

export default component.exports